<template>
  <router-view />
</template>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  font-size: 14px;
}
</style>
